/* ============================================
   GIPSY ONLINE - Custom JS Enhancements
   Sticky ATC, Back to Top
   DO NOT DELETE
   ============================================ */

/*
  NOTE: Custom Quick Add Modal has been REMOVED.
  Dawn's built-in "Choose options" quick add modal is better
  for multi-variant products (size, color, fabric).
*/

/* --- Sticky Add to Cart (Product Page) --- */
class GipsyStickyATC {
  constructor() {
    this.stickyBar = document.querySelector('.gipsy-sticky-atc');
    this.productForm = document.querySelector('product-info .product-form');
    if (!this.stickyBar || !this.productForm) return;
    this.init();
  }

  init() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.stickyBar.classList.add('visible');
        } else {
          this.stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(this.productForm);

    const stickyBtn = this.stickyBar.querySelector('.gipsy-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const mainBtn = this.productForm.querySelector('[name="add"]');
        if (mainBtn) mainBtn.click();
      });
    }
  }
}

/* --- Back to Top --- */
class GipsyBackToTop {
  constructor() {
    this.btn = document.querySelector('.gipsy-back-to-top');
    if (!this.btn) return;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 600) {
        this.btn.classList.add('visible');
      } else {
        this.btn.classList.remove('visible');
      }
    }, { passive: true });
    this.btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}

/* --- Init on DOM ready --- */
document.addEventListener('DOMContentLoaded', () => {
  new GipsyStickyATC();
  new GipsyBackToTop();
});
